import {
    getStorage,
    ref,
    uploadString,
    getDownloadURL,
    FirebaseStorage,
} from 'firebase/storage'
import { firebaseApp } from './init-firebase'
import { SERVICE_IMAGES_BUCKET } from '../../consts'

let storageInstance: FirebaseStorage | null = null

const getServiceImagesStorage = (): FirebaseStorage => {
    if (!storageInstance) {
        storageInstance = getStorage(firebaseApp, SERVICE_IMAGES_BUCKET)
    }
    return storageInstance
}

const getFileExtension = (imageBase64: string): string => {
    switch (imageBase64.charAt(0)) {
        case '/':
            return 'jpg'
        case 'i':
            return 'png'
        case 'R':
            return 'gif'
        case 'U':
            return 'webp'
    }

    return ''
}

const getMimeTypeByExtension = (extension: string): string => {
    switch (extension.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg'
        case 'png':
            return 'image/png'
        case 'gif':
            return 'image/gif'
        case 'webp':
            return 'image/webp'
    }

    return ''
}

/**
 * Upload service image (base64) to Firebase Storage and return its public URL.
 *
 * @param {string} deviceUid
 * @param {string} imageName
 * @param {string} imageBase64
 * @return {Promise<string>}
 */
export const uploadServiceImage = (
    deviceUid: string,
    imageName: string,
    imageBase64: string,
): Promise<string> => {
    const extension = getFileExtension(imageBase64)

    const fileRef = ref(getServiceImagesStorage(), `${deviceUid}/${imageName}.${extension}`)

    const metadata = {
        contentType: getMimeTypeByExtension(extension),
    }

    return uploadString(fileRef, imageBase64, 'base64', metadata)
        .then(snapshot => getDownloadURL(snapshot.ref))
}

/**
 * Build a thumbnail URL from a stored image URL by injecting the thumb path
 * and 300x300 size suffix that the cloud-function thumbnail pipeline produces.
 *
 * @param {string} imageLink
 * @return {string}
 */
export const getThumbnail = (imageLink: string): string => {
    const imageLinkSplit = [...imageLink.replace('%2F', '%2Fthumb%2F').split('.')]
    imageLinkSplit[imageLinkSplit.length - 1] = imageLinkSplit[imageLinkSplit.length - 1].replace('jpg', '___300x300.jpg')

    return imageLinkSplit.join('.').replace('.___', '_')
}
